import {Comms} from "@/app/Comms";
import { CommsFamiglia } from "./CommsFamiglia";
import { CommsResponsabilita } from "./CommsResponsabilita";

export class Starter {
    protected static instance: Starter;
    protected constructor() {
        //keep it protected to help with the singleton instance
    }

    public static getInstance(): Starter {
        if (!Starter.instance) {
            Starter.instance = new Starter();
        }
        return Starter.instance;
    }

    public setup(): void {
        //setup comms and data
        let comms:Comms = Comms.getInstance();
        comms.setup();

        let commsFamiglia:CommsFamiglia = CommsFamiglia.getInstance();
        commsFamiglia.setup();

        let commsResponsabilita:CommsResponsabilita = CommsResponsabilita.getInstance();
        commsResponsabilita.setup();
    }
}